import { isNonEmptyString } from '~/src/common';

export function extractDescription<T extends { snippet?: string; description?: string }>(data: T) {
  const description = isNonEmptyString(data?.description)
    ? data?.description
    : isNonEmptyString(data?.snippet)
    ? data.snippet
    : '';

  return description;
}
